import React from 'react';
import './App.css';
import { Auth0Provider } from "@auth0/auth0-react";
import Router from "./router";
import "./index.css";

function App() {
    // Calculate callback URL dynamically
    const redirectUri = window.location.origin;

    return (
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN || ""}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ""}
            authorizationParams={{
                redirect_uri: redirectUri,
                audience: process.env.REACT_APP_AUTH0_AUD || "",
                scope: "read:current_user update:current_user_metadata openid profile email",
            }}
            cacheLocation="localstorage" // Store tokens in localStorage instead of sessionStorage
            useRefreshTokens={true} // Enable refresh tokens
        >
            <Router />
        </Auth0Provider>
    );
}

export default App;